
import FileInput from "../../../common/input/FileInput";

export default function FieldVideo({ onChange }) {
	return (
		<FileInput onChange={onChange} label="ویدئوی معرفی کارگاه" accept="video/*" />
	);
}
